export default "__VITE_ASSET__DAAzC65T__"